<template>
  <div>
    <p class="title">预约信息</p>
    <table class="c-talbe">
      <tr>
        <td class="text-right" width="150">咨询日期</td>
        <td v-if="appoint">{{ appoint.planDate }}</td>
      </tr>
      <tr>
        <td class="text-right">咨询时间</td>
        <td v-if="appoint">{{ appoint.planStartTime }}-{{ appoint.planEndTime }}</td>
      </tr>
      <tr>
        <td class="text-right">咨询室</td>
        <td v-if="appoint.room">{{ appoint.room.name }}</td>
      </tr>
      <tr>
        <td class="text-right">咨询地点</td>
        <td v-if="appoint.room">{{ appoint.room.address }}</td>
      </tr>
      <tr>
        <td class="text-right">咨询师</td>
        <td>
          <el-avatar
            v-if="appoint.teacher"
            shape="square"
            :size="64"
            :src="appoint.teacher.headImage"
          ></el-avatar>
          <p class="text-center"  v-if="appoint.teacher">{{ appoint.teacher.teacherName }}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    appoint: {},
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
</style>
